import React, { useEffect, useState } from "react";
import axios from '../axios/axiosconf';
import { useHistory } from "react-router";
import logo from '../../resources/img/logo-2.png';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

function SetPassword() {

    //const queryParams = new URLSearchParams(window.location.search);

    const search = useLocation().search;
    const token = new URLSearchParams(search).get('token');
    const email = new URLSearchParams(search).get('email');

    const [tokenIsvalid, setTokenIsvalid] = useState(false);
    const [password, setPassword] = useState();
    const [passwordConfirm, setPasswordConfirm] = useState();
    const [loading, setLoading] = useState(false);
    //const [token, setToken] = useState(queryParams.get('token'));
    //const [email, setEmail] = useState(queryParams.get('email'));
    const [msg, setMsg] = useState();
    const [idUser, setIduser] = useState(0);
    const [feedbackType, setFeedbackType] = useState('invalid-feedback visible');

    const [errorList, setErrorlist] = useState([]);
    let history = useHistory();

    useEffect(() => {

        const config = {
            params: {
                email:email,
                token:token
            }
        }

        console.log(config);

        axios.get('/validate-inactive-user',config)
            .then(response => {
                console.log(response.data);
                if (response.data.length>0) {
                    setTokenIsvalid(true);
                    setIduser(response.data[0].id);
                }
            })
            .catch(error => {
                setTokenIsvalid(false);
            })
    }, [email, token]);



    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const config = {
            token: token,
            id:idUser,
            password: password,
            password_confirmation: passwordConfirm
        }

        axios.post('/set-password',config)
            .then(response => {

                setLoading(false);
                setErrorlist([]);
                console.log(response.data.message);
                setFeedbackType('valid-feedback visible');
                setMsg(response.data.message);

                setTimeout(() => {
                    history.push('/');
                }, 3000);
                
                if (response.status===200) {
                    //setUsername(userdata.user_name);
                    
                    //setClient(response.data);
                    //setLoggedIn(true);
                    
                }
            })
            .catch(error => {
                
                setLoading(false);
                //setFeedbackType('invalid-feedback visible');
                //setMsg(error.response.data.message);
                setFeedbackType('invalid-feedback visible');
                setErrorlist(error.response.data.errors);
                
                
                console.log(error.response.data.errors);
            });
            
    }

    if (tokenIsvalid) {

        return (
            <div className="login-page">
                <div className="login-box">
                    <div className="card card-outline card-primary">
                        <div className="card-header text-center">
                        <img src={logo} alt="Logo Smile" style={{width: '150px'}} />
                        </div>
                        <div className="card-body">
                        <p className="login-box-msg">Establecer contraseña</p>

                        <form onSubmit={handleSubmit} method="post">
                            <input type="hidden" value={token} />
                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="Contraseña" onChange={(e) => setPassword(e.target.value)} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="Confirmar contraseña" onChange={(e) => setPasswordConfirm(e.target.value)} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button type="submit" className="btn btn-primary btn-block">
                                        Aceptar&nbsp;
                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                    </button>
                                </div>
                            </div>
                            <div className={feedbackType}>
                            {msg}
                            {errorList.password}
                            </div>
                        
                        </form>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="alert alert-warning">Acceso restringido</div>
    );

}
export default SetPassword;